(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vibra-testimonials"] && !Shopify.designMode) return;
  try {
    

class VibraTestimonials extends HTMLElement {

  connectedCallback() {

    if (this._vibraInitialized) {
      return;
    }

    this._vibraInitialized = true;

    this.track =
      this.querySelector(
        '[data-vibra-testimonials-track]'
      );

    this.prevButton =
      this.querySelector(
        '[data-vibra-testimonials-prev]'
      );

    this.nextButton =
      this.querySelector(
        '[data-vibra-testimonials-next]'
      );


    if (!this.track) {
      return;
    }


    this._handlePrev =
      () => this.scrollByCard(-1);

    this._handleNext =
      () => this.scrollByCard(1);

    this._handleScroll =
      () => this.updateButtons();

    this._handleBlockSelect =
      (event) => {

        const card =
          event.target.closest?.(
            '[data-vibra-testimonial-card]'
          );

        if (
          !card ||
          !this.contains(card)
        ) {
          return;
        }

        card.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });

      };


    this.prevButton?.addEventListener(
      'click',
      this._handlePrev
    );

    this.nextButton?.addEventListener(
      'click',
      this._handleNext
    );

    this.track.addEventListener(
      'scroll',
      this._handleScroll,
      { passive: true }
    );

    this.addEventListener(
      'shopify:block:select',
      this._handleBlockSelect
    );


    this._resizeObserver =
      new ResizeObserver(
        () => this.updateButtons()
      );

    this._resizeObserver.observe(
      this.track
    );


    requestAnimationFrame(
      () => this.updateButtons()
    );

  }


  disconnectedCallback() {

    this.prevButton?.removeEventListener(
      'click',
      this._handlePrev
    );

    this.nextButton?.removeEventListener(
      'click',
      this._handleNext
    );

    this.track?.removeEventListener(
      'scroll',
      this._handleScroll
    );

    this.removeEventListener(
      'shopify:block:select',
      this._handleBlockSelect
    );

    this._resizeObserver?.disconnect();

    this._vibraInitialized = false;

  }


  scrollByCard(direction) {

    const card =
      this.track.querySelector(
        '[data-vibra-testimonial-card]'
      );

    if (!card) {
      return;
    }

    const styles =
      getComputedStyle(this.track);

    const gap =
      parseFloat(
        styles.columnGap ||
        styles.gap ||
        0
      ) || 0;

    const distance =
      card.getBoundingClientRect().width
      + gap;

    const reduceMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    this.track.scrollBy({
      left:
        distance * direction,

      behavior:
        reduceMotion
          ? 'auto'
          : 'smooth'
    });

  }


  updateButtons() {

    if (
      !this.prevButton &&
      !this.nextButton
    ) {
      return;
    }


    const maxScroll =
      this.track.scrollWidth
      - this.track.clientWidth;

    const currentScroll =
      Math.abs(
        this.track.scrollLeft
      );

    const tolerance =
      3;


    if (this.prevButton) {

      this.prevButton.disabled =
        currentScroll <= tolerance;

    }


    if (this.nextButton) {

      this.nextButton.disabled =
        currentScroll
        >= maxScroll - tolerance;

    }

  }

}


if (
  !customElements.get(
    'vibra-testimonials'
  )
) {

  customElements.define(
    'vibra-testimonials',
    VibraTestimonials
  );

}


  } catch(e) { console.error(e); }
})();
})();
